/** Split "text [label](href) text" into plain strings and { label, href } parts. */
module.exports = function inlineLinks(text) {
  var parts = [];
  var re = /\[([^\]]+)\]\(([^)]+)\)/g;
  var last = 0;
  var m;
  while ((m = re.exec(text))) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    parts.push({ label: m[1], href: m[2] });
    last = re.lastIndex;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
};



// WEBPACK FOOTER //
// ./js/inline-links.js